import {
  WIDGET_CLIENTS_DONUT,
  WIDGET_LABELS_DONUT,
  WIDGET_LINKED_WORK_DONUT,
  WIDGET_PROJECTS_DONUT,
  WIDGET_TEAMS_DONUT,
} from 'constants/widgets';

const COLOR_PALETTE = [
  '#ef6eb4',
  '#eb72bc',
  '#e775c3',
  '#e379ca',
  '#dd7dd0',
  '#d881d7',
  '#d285dc',
  '#cc89e2',
  '#c58de7',
  '#be91eb',
  '#b795ef',
  '#b099f3',
  '#a89cf6',
  '#a1a0f9',
  '#99a3fb',
  '#91a7fd',
  '#89aafe',
  '#81adff',
  '#78afff',
  '#6eb1fe',
  '#64b2fc',
  '#5ab4fb',
  '#50b5f8',
  '#45b6f6',
  '#3bb7f3',
  '#30b8f0',
  '#25b8ec',
  '#1bb9e8',
  '#10b9e4',
  '#06bae0',
  '#02badc',
  '#05bad7',
  '#0ebad2',
  '#17bacd',
  '#20bac8',
  '#29bac3',
  '#29babf',
  '#21bbbb',
  '#1bbbb7',
  '#16bcb2',
  '#16bcad',
  '#18bca8',
  '#1ebca2',
  '#25bc9c',
  '#2cbc96',
  '#34bc8f',
  '#3cbc88',
  '#44bc81',
  '#4cbb7a',
  '#54bb72',
  '#5bba6b',
  '#63b963',
  '#6bb85c',
  '#72b754',
  '#7ab64d',
  '#82b445',
  '#8ab23e',
  '#91b037',
  '#99ae30',
  '#a0ac2a',
  '#a8aa23',
  '#afa71d',
  '#b7a418',
  '#bea113',
  '#c59e10',
  '#cc9b0f',
  '#d39710',
  '#da9313',
  '#e18f17',
  '#e78b1c',
  '#ee8722',
  '#f48228',
];

const COLOR_PALETTE_STEP_PERCENT = 100 / COLOR_PALETTE.length;

export const getColor = (percent: number) => {
  const index = Math.min(
    Math.floor(percent / COLOR_PALETTE_STEP_PERCENT),
    COLOR_PALETTE.length - 1
  );
  return COLOR_PALETTE[index];
};

export const DONUT_THICKNESS = 25;

export const getGroupLabel = (dataCount: number, widgetType: string) => {
  let label;
  switch (widgetType) {
    case WIDGET_PROJECTS_DONUT:
      label = 'project';
      break;
    case WIDGET_CLIENTS_DONUT:
      label = 'client';
      break;
    case WIDGET_TEAMS_DONUT:
      label = 'team';
      break;
    case WIDGET_LABELS_DONUT:
      label = 'tag';
      break;
    case WIDGET_LINKED_WORK_DONUT:
      label = 'work item';
      break;
    default:
      label = '???';
      break;
  }

  return `${dataCount} ${label}${dataCount !== 1 ? 's' : ''}`;
};

interface PieChartInternalState {
  activeCoordinate: unknown;
  activeItem: unknown;
  activePayload: unknown;
  formatedGraphicalItems: Array<{
    props: {
      sectors: Array<{
        cx: unknown;
        cy: unknown;
        tooltipPayload: unknown;
        tooltipPosition: unknown;
      }>;
    };
  }>;
  isTooltipActive: boolean;
}

/**
 * This is a hacky way of enabling pie chart tooltips when hovering over the items in the legend,
 * since we're tampering with Recharts internals. But there doesn't seem to be any other way of
 * hooking into the tooltip activation.
 *
 * TODO: Revisit before Recharts 2.0.
 */
export const setActiveTooltip = (pieChart: React.Component | null, index?: number) => {
  if (!pieChart) {
    return;
  }

  if (typeof index === 'undefined') {
    pieChart.setState({
      isTooltipActive: false,
    } as PieChartInternalState);
    return;
  }

  const state = pieChart.state as PieChartInternalState;
  const activeItem = state?.formatedGraphicalItems?.[0]?.props?.sectors?.[index];
  if (activeItem) {
    pieChart.setState({
      activeCoordinate: activeItem.tooltipPosition ?? { x: activeItem.cx, y: activeItem.cy },
      activeItem,
      activePayload: activeItem.tooltipPayload,
      isTooltipActive: true,
    } as PieChartInternalState);
  }
};
